import React, { useContext, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import services from "../../services/Services";
import { QRCodeSVG } from "qrcode.react"
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import Spinner from "../MPPSpinner";

export const D2DmppPage = (props) => {
    const {
        partnerId,
        merchantName,
        totalAmount,
        brandings: {
            creditCardImage,
            synchronySetPayIn4Image,
            mppPrimaryColors
        },
        mppConfig: {
            buttonTextapplicationLink,
            subtitleapplicationLink,
            subtitleNoteapplicationLink,
            footerTextapplicationLink,
            revolving,
            paylater,
            circleCheckimg,
        },
        queryValues: {
            d2dFlowType,
            childSyfMerchantNumber,
            productCategoryNames,
            offerNumber1,
            siteCode,
            clientTransId
        },
    } = useContext(ThemeContext)
    const {
        setErrorPageMppApplication,
        setSuccessPageMppApplication
    } = props;
    const [d2dMailId, setD2dMailId] = useState("");
    const [submittedEmail, setSubmittedEmail] = useState("");
    const [emailEntryError, setemailEntryError] = useState("");
    const [isSpinnerDisplayed, setSpinnerDisplayed] = useState("none");
    const emailRegex = /^[\w\-+&*]+(?:\.[\w\-_+&*]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,8}$/

    const handleChange = (event) => {
        setD2dMailId(event.target.value);
        setemailEntryError("");
    }
    const [qrUrl, setQrUrl] = useState("");
    const mailBtnClick = () => {
        const requestPayLoad = {
            partnerId,
            d2dMailId,
            totalAmount,
            siteCode,
            merchantName,
            token: clientTransId,
            productName: merchantName,
            promoCodes: offerNumber1 ? offerNumber1.split(",") : [],
            promotionalTags: productCategoryNames ? productCategoryNames.split(",") : [],
            saleAmount: d2dFlowType === "D2D_BUY" ? totalAmount : null,
            "channelId": "",
            "cipher.merchantId": "",
            "cipher.storeMid": childSyfMerchantNumber,
        }
        if (emailRegex.test(d2dMailId)) {
            setSubmittedEmail(d2dMailId);
            setSpinnerDisplayed("block");
            services.fetchMppFromD2DLink(requestPayLoad)
                .then((response) => {
                    if (!response.url) {
                        setSuccessPageMppApplication(false)
                        setErrorPageMppApplication(true);
                        throw new error("mppApplication Link API failed");
                    }
                    setQrUrl(response.url);
                    setSpinnerDisplayed("none");
                    document.getElementsByClassName("d2dConfirmArea")[0].style.visibility = "visible";
                }).catch(() => {
                    setSuccessPageMppApplication(false)
                    setErrorPageMppApplication(true);

                })
        }
        else {
            setemailEntryError("Enter valid email address");
        }
    }
    return (
        <React.Fragment>
            <div className="d2dSendLink modal-body">
                <div className="approvalBanner">
                    <div className="productImg">
                        {
                            ((revolving && paylater) ?
                                <>
                                    <img className="revolving" alt="EESHORT Credit Card" title="EESHORT Credit Card"
                                        src={creditCardImage}
                                    />
                                    <span className="productsDivider" />
                                    <img className="setPayImg" alt="payLater" title="paylater Credit Card"
                                        src={synchronySetPayIn4Image}
                                    />
                                </>
                                : (revolving)
                                    ? <img className="revolving" alt="EESHORT Credit Card" title="EESHORT Credit Card"
                                        src={creditCardImage}
                                    />
                                    : (paylater &&
                                        <img className="setPayImg" alt="payLater" title="paylater Credit Card"
                                            src={synchronySetPayIn4Image}
                                        />
                                    ))
                        }
                    </div>

                    <p className="prequalifyHeader">
                        {subtitleapplicationLink}
                    </p>
                    <p className="decisionTxt">
                        {subtitleNoteapplicationLink}
                    </p>
                </div>
                <div className="sendLink">
                    <Form.Floating>
                        <Form.Control
                            id="floatingInputCustom"
                            type="email"
                            placeholder="Applicant Email"
                            className="mailInput"
                            value={d2dMailId}
                            onChange={handleChange}
                        />
                        <label className="floatingInputCustom" htmlFor="floatingInputCustom">Applicant Email</label>
                        {emailEntryError && (
                            <p className="emailEntryInputError">{emailEntryError}</p>
                        )}
                    </Form.Floating>

                    <Button
                        className="d2dMailBtn"
                        onClick={mailBtnClick}
                        style={{
                            backgroundColor: mppPrimaryColors,
                            borderColor: mppPrimaryColors,
                        }}
                    > {buttonTextapplicationLink}
                    </Button>

                </div>
                <div className="d2dConfirmArea">
                    <div className="d2dToast">
                        <img src={circleCheckimg} className="rounded" alt="" />
                        <div className="inputMail">
                            <p>Email sent to <strong>{submittedEmail}</strong> </p>
                        </div>
                    </div>
                    <div className="toastQRcodeDivider">OR</div>
                    <div className="qrCodeScanner">
                        <span>Scan QR code to get started!</span>
                        <div className="qrCodeImg">
                            {qrUrl &&
                                <QRCodeSVG
                                    value={qrUrl}
                                    size="200"
                                />
                            }
                        </div>
                    </div>

                </div>
                <p className="d2dSubFooter">
                    {footerTextapplicationLink}
                </p>
            </div>
            <Spinner isDisplayed={isSpinnerDisplayed}></Spinner>
        </React.Fragment>
    );
};